<ng-container *ngIf='appService.languages.value && appService.languages.value.length'>
	<!-- desktop -->
	<div class="desktop">
		<select (change)='onChange($event)' class="selectpicker" data-width="fit" [disabled]='appService.loadingLanguages.value'>
			<ng-container *ngFor='let code of appService.languages.value'>
				<ng-container *ngIf='appService.defaultLangs[code]'>
					<option [value]='code' [selected]='code === translate.currentLang'>
						{{appService.defaultLangs[code]?.description}}
					</option>
				</ng-container>
			</ng-container>
		</select>
		<span class='fa fa-spinner fa-spin' style="position: relative; left: 10px;" *ngIf='appService.loadingLanguages.value'></span>
	</div>
	<!-- mobile -->
	<li class="dropleft langs mobile-switcher">
		<a class="dropdown-toggle" data-toggle="dropdown">{{translate.currentLang | uppercase}}</a>
		<ul class="dropdown-menu">
			<ng-container *ngFor='let code of appService.languages.value'>
				<li (click)='onChange(code)'><a>{{code | uppercase}}</a></li>
			</ng-container>
		</ul>
	</li>
</ng-container>